import { render, staticRenderFns } from "./AsideCommentsSection.vue?vue&type=template&id=48a77ceb&"
import script from "./AsideCommentsSection.vue?vue&type=script&lang=js&"
export * from "./AsideCommentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports